module.exports = __webpack_public_path__ + "media/reimagine.dabe7c2c.mp4";